// Module
var code = "<ul class=\"controls\"></ul> <% if(!autoSave){ %> <div class=\"actions card\"></div> <% }%> ";
// Exports
export default code;